import React, { Component } from "react";
import axios from "axios";
import { Navigate } from "react-router-dom";
import {
  Button,
  Collapse,
  Alert,
  IconButton,
  Typography,
  Box,
  FormControl,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Serverurl from "./Apiurl";
import JoditEditor from "jodit-react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";


const fieldStyle = {
  backgroundColor: "#f5f6f8",
  borderRadius: "10px",
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    backgroundColor: "#f5f6f8",
    "& fieldset": {
      borderColor: "#d1d5db",
    },
    "&:hover fieldset": {
      borderColor: "#9ca3af",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#1976d2",
    },
  },
  "& .MuiInputBase-input": {
    padding: "12px 14px !important",
   
    color: "#000",
  },
};

export default class AddTerms extends Component {
  constructor(props) {
    super(props);
	this.editor = null;
    this.state = {
      tc_id: 0, // 0 forces INSERT on backend
      tc_content: "",
      tc_type: "",
      redirect: false,
      btndisabled: false,
      submitbtn: "Save",
      erropen: false,
      errormessage: "",
	  
      pagename: "",
    };
  }

  getParameterByName(name, url) {
    if (!url) url = window.location.href;
    url = url.toLowerCase();
    name = name.replace(/[\[\]]/g, "\\$&").toLowerCase();
    const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
    const results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  componentDidMount() {
    // 1. Check user login session
    if (localStorage.getItem("GBuserid") == null) {
      this.setState({
        redirect: true,
        pagename: "/Businesslogin",
      });
      return;
    }

    const tcid = this.getParameterByName("tcid");
    const typeFromUrl = this.getParameterByName("type");

    // 2. Handle Edit vs Add
    if (tcid) {
      this.getTermData(tcid);
    } else {
      // FORCE tc_id to 0 for creation, and pre-fill tc_type if passed in URL
      const defaultType =
    this.props.quotationMode ||
    typeFromUrl ||
    "1";

  this.setState({
    tc_id: 0,
    tc_type: String(defaultType),
  });
    }
  }

  getTermData = (id) => {
    axios
      .get(Serverurl + "ajaxtermsconditions.php?action=getall&tc_id=" + id)
      .then((res) => {
        if (res.data && res.data.length > 0) {
          const term = res.data[0];
          this.setState({
            tc_id: term.tc_id,
            tc_content: term.tc_content,
            tc_type: term.tc_type || "1",
          });
        }
      });
  };

  myChangeHandler = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleErrorclose = () => {
    this.setState({ erropen: false, errormessage: "" });
  };

  handleSubmit = (e) => {
  e.preventDefault();

  let content = this.state.tc_content;

  if (this.editor && this.editor.value) {
    content = this.editor.value;
  }

  const plainContent = content
    ? content.replace(/<[^>]*>/g, "").trim()
    : "";

  if (!plainContent) {
    return this.showError("Please Enter Content");
  }

  if (!this.state.tc_type) return this.showError("Please Select Type");

    this.setState({ btndisabled: true, submitbtn: "Processing..." });

    const formData = new FormData();
    formData.append("action", "insertorupdate");
    formData.append("tc_id", this.state.tc_id); // Sending 0 triggers INSERT in backend
   formData.append("tc_content", content);
    formData.append("tc_type", this.state.tc_type);
    formData.append("tc_bu_id", localStorage.getItem("GBuserid"));
    formData.append("userid", localStorage.getItem("GBuserid"));

    axios
      .post(Serverurl + "ajaxtermsconditions.php", formData)
      .then((res) => {
        const termId = Array.isArray(res.data)
          ? res.data[0]?.tc_id
          : typeof res.data === "object"
          ? res.data.tc_id
          : res.data;

        if (termId && termId !== -1) {
			
			
          if (this.props.quotationMode || this.props.invoiceMode) {
 const term = {
  tc_id: termId,
  tc_content: content,
  tc_type: this.state.tc_type,
};

this.props.onTermAdded(term);
} else {
  this.setState({
    redirect: true,
    pagename: "/Termsandconditions?type=" + this.state.tc_type,
  });
}
        } else if (termId === -1) {
          this.showError("Term title already exists");
        } else {
          this.showError("Error saving term");
        }
      })
      .catch(() => {
        this.showError("Something went wrong while saving.");
      });
  };

  showError = (msg) => {
    this.setState({
      erropen: true,
      errormessage: msg,
      btndisabled: false,
      submitbtn: "Save",
    });
  };

  Handledescripion = (newValue) => {
    this.setState({
      tc_content: newValue,
    });
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to={this.state.pagename} />;
    }

    const isNew = Number(this.state.tc_id) === 0;
	  const config = {
  readonly: false,
  height: 400,
  style: {
    background: '#f4f4f4', // Change editor background color here
  },
};
    return (
      <div className="formmain">
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3, marginBottom:'10px' }}>
         
		  {!this.props.quotationMode && (
            <IconButton onClick={() => this.setState({ redirect: true, pagename: "/Termsandconditions" })}>
                <ChevronLeftIcon
  className="global-back-arrow"
  onClick={() => window.history.back()}
/>
          </IconButton>
 )}		   <Typography variant="h4" sx={{ marginTop:1,     marginRight: "14%" }}>Terms and Conditions
          </Typography>
        </Box>

        <Collapse in={this.state.erropen}>
          <Alert
            severity="error"
            action={
              <IconButton
                aria-label="close"
                size="small"
                onClick={this.handleErrorclose}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
          >
            {this.state.errormessage}
          </Alert>
        </Collapse>

        <form onSubmit={this.handleSubmit}>
			{/* <Typography>
            <span className="validation">*</span>Content
			</Typography>*/}
	
     <JoditEditor
  ref={(editor) => {
    this.editor = editor;
  }}
  value={this.state.tc_content}
  config={{
    style: {
      background: '#f0f4f7', 
    },
    removeButtons: ['video'],
  }}
  tabIndex={8}
  onChange={this.Handledescripion}
/>

          {/* Show dropdown when creating a new item */}
          {isNew && (
            <FormControl fullWidth margin="normal">
			{/* <Typography>
                <span className="validation">*</span>Type
			</Typography>*/}
              <select
                name="tc_type"
                value={this.state.tc_type}
                onChange={this.myChangeHandler}
                style={{ width: "100%", padding: "10px",      background: '#f0f4f7',marginTop: "10px" }}
              >
                <option value="">Select Type</option>
                <option value="1">Quotation</option>
                <option value="2">Purchase Order</option>
				{localStorage.getItem("GBuserid") !== "1" && (
  <option value="3">Invoice</option>
)}
              </select>
            </FormControl>
          )}

          <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
            <Button
              type="submit"
              variant="contained"
              className="primartybtn"
              disabled={this.state.btndisabled}
					  sx={{
   
    borderRadius: "20px",
    minWidth: "110px",
  }}  
            >
              {this.state.submitbtn}
            </Button>
          </Box>
        </form>
      </div>
    );
  }
}